import { render, staticRenderFns } from "./DecoderSelect.vue?vue&type=template&id=485e52a3&"
import script from "./DecoderSelect.vue?vue&type=script&lang=js&"
export * from "./DecoderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports